import { getConfig } from '@components/Config';
import { formatPhoneNumber } from '@components/Text';

type OrganizationFooterData = {
  name?: string;
  email?: string;
  phoneNumber?: string;
}

const PLATFORM_NAME = getConfig('PLATFORM_NAME') as string;

const getOrganizationFooterHtml = (
  organization: OrganizationFooterData = {},
): string => {
  const {
    name = PLATFORM_NAME,
    email,
    phoneNumber,
  } = organization;

  const rows: string[] = [
    'Regards,',
    name,
  ];

  const hasEmail = Boolean(email);

  if (hasEmail) {
    rows.push(`Email: <a href="mailto:${email}">${email}</a>`);
  }

  const hasPhoneNumber = Boolean(phoneNumber);

  if (hasPhoneNumber) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber) || phoneNumber;
    rows.push(
      `Phone: <a href="tel:${phoneNumber}">${formattedPhoneNumber}</a>`,
    );
  }

  const html = rows
    .join('<br/>');

  return html;
};

export default getOrganizationFooterHtml;
